// OfferPromo.tsx
import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../store';
import * as OfferStore from '../store/Offer';
import * as StockStore from "../store/Stock";
import OfferFilters from './OfferFilters';
import OfferPromotions from './OfferPromotions';
import OfferTable from './OfferTable';
import DialogModal from "./DialogModal";
import { getText } from '../utils/texts';

interface OfferPromoProps {
    dialogOpenOffer: { isOpen: boolean; message: string };
    requestItemOfferResult: (timestamp: number) => void;
    closeDialogModalOffer: () => void;
    updateOfferFilter: (filter: any) => void;
}

class OfferPromo extends React.PureComponent<OfferPromoProps> {
    private isDarkModeCache: boolean | null = null;

    componentDidMount() {
        this.props.requestItemOfferResult(new Date().getTime());
    }

    componentWillUnmount() {
        this.props.updateOfferFilter({});
    }

    isDarkMode = () => {
        if (this.isDarkModeCache !== null) return this.isDarkModeCache;

        if (typeof window !== 'undefined') {
            const isTrueSet = localStorage.getItem('isDarkMode');
            this.isDarkModeCache = isTrueSet === 'true';
        } else {
            this.isDarkModeCache = false;
        }
        return this.isDarkModeCache;
    }

    render() {
        const isDark = this.isDarkMode();

        return (
            <div style={{ height: "100%" }}>
                {/* Chaque composant est connecté directement au store */}
                <OfferFilters isDarkMode={isDark} />
                <OfferPromotions isDarkMode={isDark} />
                <OfferTable isDarkMode={isDark} />

                <DialogModal
                    contentLabel="Offer dialog"
                    contentStyle={{
                        background: isDark ? "#181F3A" : "#FFFFFF",
                        color: isDark ? "#FFFFFF" : "#3B4370",
                        border: isDark ? "1px solid #181F3A" : "1px solid rgb(204, 204, 204)",
                        width: 500,
                        maxHeight: 400,
                        overflowY: "auto",
                        overflowX: "hidden"
                    }}
                    title={getText("OfferDialogTitle")}
                    isOpen={this.props.dialogOpenOffer.isOpen}
                    onRequestClose={() => this.props.closeDialogModalOffer()}>
                    <div>
                        <h4 style={{ margin: "40 30", overflowWrap: 'break-word' }}>
                            {this.props.dialogOpenOffer.message}
                        </h4>
                        <button
                            className="btn btn-secondary btn-sm"
                            type="button"
                            style={{ width: '100%', height: 40, fontSize: 15 }}
                            onClick={() => this.props.closeDialogModalOffer()}>
                            {getText("MaintenanceCorrect")}
                        </button>
                    </div>
                </DialogModal>
            </div>
        );
    }
}

const mapStateToProps = (state: ApplicationState) => ({
    dialogOpenOffer: state.offer.dialogOpenOffer
});

const mapDispatchToProps = {
    requestItemOfferResult: OfferStore.actionCreators.requestItemOfferResult,
    closeDialogModalOffer: OfferStore.actionCreators.closeDialogModalOffer,
    updateOfferFilter: OfferStore.actionCreators.updateOfferFilter
};

export default connect(mapStateToProps, mapDispatchToProps)(OfferPromo);